import Vue from 'vue';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

Swiper.use([Navigation, Pagination]);

Vue.component('three-columns-block-slider', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            breakpoint: true,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.breakpoint = window.matchMedia('(min-width:1024px)');

        // keep an eye on viewport size changes
        this.breakpoint.addListener(this.breakpointChecker);

        // kickstart
        this.breakpointChecker();

        // this.swiperInit();
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        breakpointChecker() {
            const breakpoint = window.matchMedia('(min-width:1024px)');

            // if larger viewport and multi-row layout needed
            if (breakpoint.matches === true) {
                // clean up old instances and inline styles when available
                if (this.slider !== undefined) this.slider.destroy(true, true);

                // or/and do nothing

                // else if a small viewport and single column layout needed
            } else if (breakpoint.matches === false) {
                // fire small viewport version of swiper
                return this.swiperInit();
            }
        },

        swiperInit() {
            this.slider = new Swiper(this.$refs.slider, {
                modules: [Navigation, Pagination],
                loop: false,
                breakpoints: {
                    0: {
                        slidesPerView: 1.2,
                        spaceBetween: 20,
                        slidesOffsetAfter: 40,
                    },
                    600: {
                        slidesPerView: 2.5,
                        spaceBetween: 40,
                        slidesOffsetAfter: 80,
                    },
                    1024: {
                        slidesPerView: 3.3,
                        spaceBetween: 40,
                        slidesOffsetAfter: 80,
                    },
                },
                navigation: {
                    nextEl: this.$refs.threeColumnsNext,
                    prevEl: this.$refs.threeColumnsPrev,
                },
                pagination: {
                    el: this.$refs.threeColumnsPagination,
                    bulletClass: 'highlighted-item__pagination-bullet',
                    bulletActiveClass: 'highlighted-item__pagination-bullet--active',
                },
            });
        },
    },
});
